// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "1e468b65433d9282c32876297cf4bf570c85f4a3/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};